<template>
    <div class="report-biometric-value"
         v-if="scoreDef">

        {{ label }}
        <!-- NB: prevent insertion of &nbsp; between value and units -->
        <span class="metric-value">
            {{ Number(scoreOrValue).toFixed(precision) }}
        </span>
        <span class="metric-units">
            &nbsp;{{ units }}
        </span>

    </div>
</template>

<script>
    import Vue from 'vue'

    /**
     * Displays the value of a response to a biometric question
     */
    export default Vue.extend({
        props: {
            scoreName: String,
            labelKey: String, // optional
            units: String,
            precision: { type: Number, default: 0 }
        },
        computed: {
            scoreDef () {
                return this.$store.state.patientParticipant.latestScoreDefs[this.scoreName]
            },
            label () {
                return this.labelKey ? `${this.$i18n.gt(this.labelKey)}:` : ''
            },
            scoreOrValue () {
                if (this.scoreDef) {
                    return this.scoreDef.thresholds_are_for_values
                        ? this.scoreDef.score.value
                        : this.scoreDef.score.score
                } else {
                    return null
                }
            },
        }
    })
</script>

<style lang="scss">
    .report-biometric-value {
        .metric-value {
            font-size: 16px;
            background: #e0e0e0;
            padding: 2px 6px;
        }

        .metric-units {
            color: #aaaaaa;
        }
    }
</style>
